module.exports = __webpack_public_path__ + "img/nein_aktiv.svg";